export var D2CRefundPolicyRuleCriterion;
(function (D2CRefundPolicyRuleCriterion) {
    D2CRefundPolicyRuleCriterion["PICK_UP_AT"] = "PICK_UP_AT";
    D2CRefundPolicyRuleCriterion["CREATED_AT"] = "CREATED_AT";
})(D2CRefundPolicyRuleCriterion || (D2CRefundPolicyRuleCriterion = {}));
